/**
 * Created by Administrator on 2017/7/2.
 */
import {SHOWBLOGLIST} from './actionTypes.js';

export const LoadBlogList = () => {
    return (dispatch) => {
        // axios({
        //     method: "GET",
        //     url: '/bloglist',
        //     headers: {'Access-Control-Allow-Origin': '*'}
        // }).then(function (res) {
        // }).catch(function (err) {
        //   console.log(err);
        // });
        dispatch(ShowBlogList({
        totalNumber: 207,
        currentPage: 1,
        pageNumber: 18,
        blogList: [{blogId: 1, title: '我的第一篇博客', titleImgUrl: './images/20ev2.jpg', introduce: '理解webpack4.splitChunks'},
            {blogId: 3, title: 'third blog', titleImgUrl: './images/321.jpg', introduce: 'Node Sass to Dart Sass'},
            {blogId: 4, title: 'second blog', titleImgUrl: './images/123.PNG', introduce: 'A Webpack plugin helps you build better JavaScript application'},
            {blogId: 5, title: 'first blog', titleImgUrl: './images/20ev2.jpg', introduce: 'Using Babel'},]
    }));
    }
};

export const ChangePage = (pageNumber) => {
    return (dispatch) => {
        // axios({
        //     method: "GET",
        //     url: '/bloglist/'+pageNumber,
        //     headers: {'Access-Control-Allow-Origin': '*'}
        // }).then(function (res) {
        // }).catch(function (err) {
        //   console.log(err);
        // });
                  dispatch(ShowBlogList({
                    totalNumber: 207,
                    currentPage: 1,
                    pageNumber: 18,
                    blogList: [{blogId: 1, title: '我的第一篇博客', titleImgUrl: './images/20ev2.jpg', introduce: '理解webpack4.splitChunks'},
                        {blogId: 3, title: 'third blog', titleImgUrl: './images/321.jpg', introduce: 'Node Sass to Dart Sass'},
                        {blogId: 4, title: 'second blog', titleImgUrl: './images/123.PNG', introduce: 'A Webpack plugin helps you build better JavaScript application'},
                        {blogId: 5, title: 'first blog', titleImgUrl: './images/20ev2.jpg', introduce: 'Using Babel'},]
                }));
    }
}

export const ShowBlogList = (data) => ({
    type: SHOWBLOGLIST,
    data: data
});


// WEBPACK FOOTER //
// ./src/Component/BlogListTimeLine/actions.js